import { PermissionsService } from "../../../routes/services/permissions.service";
import { IndexedDBService } from "../../../routes/services/db/indexedDb.service";
import { TranslatorService } from "../../../core/translator/translator.service";
import { ParametricsService } from "../../../routes/services/parametrics.service";
import { FirebaseService } from "../../../routes/services/firebase.service";
import { SettingsService } from "../../../core/settings/settings.service";
import { ClientsService } from "../../../routes/services/clients.service";
import { StorageService } from "../../../routes/services/storage.service";
import { SocketService } from "../../../routes/services/socket.service";
import { UsersService } from "../../../routes/services/users.service";
import { FarmService } from "../../../routes/services/farm.service";
import { AuthService } from "../../../routes/services/auth.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { HelpService } from "../../../core/help/help.service";
import { MenuService } from "../../../core/menu/menu.service";
import { NavigationEnd, Router } from "@angular/router";
import { merge, Subject, Subscription } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

import { GlobalFunction, urlClient, urlAdmin } from "../../../routes/services/globalFuntion";
import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsService } from "../../../routes/services/notifications.service";
import { VersioningService } from "../../../routes/Pages/versioning/services/versioning.service";
import { PondService } from "../../../routes/services/pond.service";

interface person {
  name: string;
  email: string;
}
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  navCollapsed = true; // for horizontal layout
  menuItems: Array<any> = []; // for horizontal layout
  personal: Array<person>;
  isNavSearchVisible: boolean;
  @ViewChild("fsbutton", { static: true }) fsbutton; // the fullscreen button

  user: any;
  /** Usuario con los datos del cliente para el modal de perfil. */
  profileUser: any = null;
  urlImage = "";

  mode = false;
  farms: any = [];
  farmData = {
    client: {},
    coordinates: [],
    device_name: "hh",
    gateway: {},
    hectares: 0,
    id: 0,
    name: "",
    off_feeders: 0,
    on_feeders: 0,
    timezone: ""
  };

  loading_farm = true;

  personal_web;
  modeSubsciption: Subscription;
  notificationSubscription: Subscription;
  farmSuscription: Subscription;

  currentVersion: any;
  newVersion: any;
  needsRefresh: boolean = false;
  url = "";
  farm_id: Number | "" = "";
  pop_notifications: any = [];

  farm_notifications = [];
  farm_selected: null | { farm_name: string; count: number; id: number; ponds?: string[] } = null;
  system_notification_count: number = 0;
  view_farm = false;

  /** Clave i18n de la seccion actual; titulo del header en compacto. */
  sectionTitle = "";
  private destroy$ = new Subject<void>();
  // ResizeObserver no esta en los tipos DOM de TypeScript 4.0
  private headerResizeObserver: any = null;

  constructor(
    public permissionsService: PermissionsService,
    private indexedDBService: IndexedDBService,
    private afMessaging: AngularFireMessaging,
    public parametryService: ParametricsService,
    public versionService: VersioningService,
    public firebaseService: FirebaseService,
    public clientsService: ClientsService,
    public storageService: StorageService,
    public globalFunction: GlobalFunction,
    public translator: TranslatorService,
    public socketService: SocketService,
    public settings: SettingsService,
    public userService: UsersService,
    public AuthService: AuthService,
    public HelpService: HelpService,
    public farmService: FarmService,
    public pondService: PondService,
    public menu: MenuService,
    public router: Router,
    public notificationsService: NotificationsService,
    private elementRef: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    private modalService: NgbModal
  ) {
    window.addEventListener("beforeunload", (e) => {
      e.returnValue = "";

      this.socketService.unSuscribeSocket();
      this.modeSubsciption.unsubscribe();
    });

    if (localStorage.getItem("version")) this.currentVersion = localStorage.getItem("version");

    if (this.globalFunction.validateSoloAdmin()) {
      this.getLastVersion();
    }

    // show only a few items on demo
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
  }

  requestPermission = async (dele = false) => {
    let token: any = await this.afMessaging.getToken.toPromise();

    console.log("ESTE ES EL TOKEN QUE DEBES DE VALIDAR EN EL BACKEND: ", token);
    if (dele && token) {
      const del = await this.afMessaging.deleteToken(token).toPromise();
      if (del) {
        let new_token: any = await this.afMessaging.getToken.toPromise();
        token = new_token;
      }
    }
    if (!token) {
      const new_token = await this.afMessaging.requestToken.toPromise();
      if (new_token) {
        token = new_token;
      }
    }

    try {
      if (token) {
        token && this.validateTokenNotifications(token);
      } else {
        this.afMessaging.requestToken.subscribe((token) => {
          token && this.validateTokenNotifications(token);
        });
      }
    } catch (error) {}
  };
  validateTokenNotifications = async (token) => {
    const suscribe_topic_all = async () => {
      await this.firebaseService.firebaseTopicSuscribeAll({}).toPromise();
    };
    const saveToken = async (name) => {
      let data = await this.firebaseService.saveToken({ name, token, type: 0 }).toPromise();

      if (data) {
        localStorage.setItem("name_firebase", name);
        suscribe_topic_all();
      }
    };
    const refreshToken = async (id, name) => {
      this.firebaseService.refreshToken(id, { name, token, type: 0 }).subscribe((item) => {
        localStorage.setItem("name_firebase", name);
        suscribe_topic_all();
      });
    };

    let tokens = await this.firebaseService.getTokentFirebase(`?ordering=-id`).toPromise();

    let nameDevice = `${this.globalFunction.detectBrowserName()} ${tokens.length + 1}`;

    if (tokens.length === 0) {
      await saveToken(nameDevice);
    }
    if (tokens.length > 0) {
      let name_firebase = localStorage.getItem("name_firebase");

      if (name_firebase) {
        let findToken = tokens.findIndex((item) => item.name === name_firebase);

        if (findToken === -1) {
          await saveToken(name_firebase);
        }
        if (findToken >= 0) {
          await refreshToken(tokens[findToken].id, name_firebase);
        }
      }
      if (!name_firebase) {
        await saveToken(nameDevice);
      }
    }
  };

  countValidateUrl: number = 0;
  notifications: Array<any> = [];
  countNotifications: number = 0;
  loading_notifications = false;
  loading_farm_notifications = false;

  ngOnInit() {
    this.unReadPerFarm();

    // Titulo de la seccion (compacto): se recalcula al navegar y cuando cambia el menu
    merge(this.router.events.pipe(filter((event) => event instanceof NavigationEnd)), this.menu.getMenu$())
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateSectionTitle());

    this.afMessaging.messages.subscribe((resp: any) => {
      console.log(resp);

      this.refreshNotificationsOnOpen();
      let extra = null;
      if (resp && resp.data && resp.data.extra) {
        try {
          extra = { ...JSON.parse(resp.data.extra) };
        } catch (error) {
          extra = null;
        }
      }
      const notification = {
        ...resp,
        data: {
          ...resp.data,
          extra
        }
      };
      this.storageService.setItem("notifications", notification);
      this.pop_notifications.push(notification);
      /* setTimeout(() => {
        this.pop_notifications.shift();
      }, 5000); */
    });

    /*   this.sendNotification() */

    this.requestPermission();
    this.personal_web = this.storageService.localValue;

    if (this.personal_web) {
      this.uploadPreferenceHeader(this.personal_web);

      let idClient = this.storageService.getClientID();
      this.temporalClient = idClient;

      if (idClient) {
        if (this.user) {
          this.urlImage = this.user.client ? this.user.client.logo : "";
        }
      } else {
        this.urlImage = "";
      }
      /* Obtenern permisos al inciar el header para empezar a validar  */
    }
    let localUser: string | null = localStorage.getItem("USER") || null;
    if (localUser) {
      const user = <any>JSON.parse(localUser);
      this.user = user;
    }
    /* takeUntil: sin limpieza, tras cerrar sesión seguía guardando filtros en cada navegación
       (incluida la landing) y la petición sin token mandaba de vuelta al login */
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event["navigationTrigger"] === "imperative") {
        this.storageService.cancelRequests();
      }
      // current_url lo guarda AppComponent en cada NavigationEnd; aqui solo se lleva la url
      if (this.router.url !== "/login") {
        this.url = this.router.url;
      }
    });

    if (!this.globalFunction.validateSoloAdmin() || this.personal_web.mode === 1) {
      const farm_id = this.storageService.localValue.farm_id;
      this.parametryService.getParametricPreference(`?farm_id=${farm_id}`).subscribe((resp) => {
        console.log("PREFERENCIA DE PARAMETRIAS", resp);
        if (resp.length > 0) {
          this.storageService.setParametryPreferences(resp[0]);
        }
      });
    }

    this.modeSubsciption = this.storageService.watchStorage("mode").subscribe(async (mode) => {
      await this.validateCurrentUrl();

      if (this.storageService.localValue) {
        let getQuery = this.storageService.getQueryFilters({
          font_size: ""
        });
        if (getQuery && getQuery.font_size) {
          this.storageService.changeFont("default", getQuery.font_size);
        } else {
          this.storageService.changeFont("default");
        }

        this.getParametricPreference(mode);
        this.unReadPerFarm();
      }
    });
  }
  getParametricPreference(mode) {
    if (!this.globalFunction.validateSoloAdmin() || mode === 1) {
      const farm_id = this.storageService.localValue.farm_id;
      this.parametryService.getParametricPreference(`?farm_id=${farm_id}`).subscribe((resp) => {
        if (resp.length > 0) {
          let resourses = resp[0];
          this.storageService.setParametryPreferences(resourses);
        }
      });
    }
  }

  getCurrentQuery() {
    const { mode } = this.storageService.localValue;
    return !mode && this.globalFunction.validateSoloAdmin() ? "query_admin" : "query_client";
  }
  validateCurrentUrl() {
    const { client, mode } = this.storageService.localValue;
    const query = this.storageService.localValue[this.getCurrentQuery()];

    if (query && query.current_url) {
      const current_url = query.current_url || "";
      if (this.router.url === current_url) {
        this.validateClientAdminUrl(mode, client, current_url);
      }
    } else {
      this.validateUrl(mode, client);
    }
  }

  validateClientAdminUrl = (mode, client, current_url) => {
    const validateText = (array, text) => {
      let filter = array.filter((item) => text.indexOf(item) !== -1);
      return filter.length > 0;
    };

    if (mode === 1 && client) {
      const validate = validateText(urlClient, current_url);

      if (!validate) {
        this.validateUrl(mode, client);
      }
    }
    if (!mode) {
      if (!validateText(urlAdmin, current_url)) {
        this.validateUrl(mode, client);
      }
    }
  };

  validateUrl = (mode, client) => {
    let localUSer = localStorage.getItem("USER");
    let user: any = localUSer ? <any>JSON.parse(localUSer) : "";
    /* si es un administrador o subcliente */
    if (!user.client && !client && !mode) {
      this.router.navigateByUrl(`/dashboard`);
    }
    /* Si es un subcliente usado como admin */
    if (mode && mode === 1 && client && !client.user.client) {
      this.router.navigateByUrl(`/dashboard`);
    }
    /* Si es un cliente usado como admin */
    if (mode && mode === 1 && !this.storageService.isAdmin()) {
      this.router.navigateByUrl(`/dashboard`);
    }
    /* Si es un cliente */
    if (!mode && !this.storageService.isAdmin()) {
      this.router.navigateByUrl(`/dashboard`);
    }
    if (mode === 0 || !mode) {
      this.router.navigateByUrl("/home");
    }
  };
  getLastVersion() {
    this.versionService.getLastVersion().subscribe((res) => {
      if (!res || !res.results || !res.results.length) return;

      this.newVersion = res.results[0].version;

      if (this.currentVersion) {
        if (parseFloat(res.results[0].version) > parseFloat(this.currentVersion)) {
          this.needsRefresh = true;
        }
      } else {
        localStorage.setItem("version", this.newVersion);
        this.currentVersion = this.newVersion;
      }
    });
  }

  refresh() {
    localStorage.setItem("version", this.newVersion);
    location.reload();
  }

  openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setFarm(value) {
    const local = this.storageService.localValue;
    const farm_id = Number(value);
    /* Validacion para cuando cambie de granja eliminar el query de pond_id  */
    let setValue = {
      ...local,
      farm_id,
      ...this.storageService.changeQueryPropiety(["pond_id", "planting_id"])
    };
    this.socketService.socketNext([
      { type: "gateways.add_listener", data: { farm: Number(value) } }
    ]);
    this.indexedDBService.clearAlldb();

    this.storageService.editPreferences(setValue)?.subscribe((resp) => {
      this.storageService.localValue.farm_id = Number(value);
      this.farm_id = value;
      this.storageService.setItem("farmId", Number(value));
      this.getParametricPreference(this.storageService.localValue.mode);
    });
  }

  setNavSearchVisible(stat: boolean) {
    // (stat);
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  /**
   * Publica el alto real del header en la variable CSS "--header-height".
   * En compacto el header cambia de alto segun el rol (selector de granja,
   * switch de cliente, aviso de actualizacion) y el contenido usa esa variable
   * como separacion superior (ver "Layout compacto" en layout.scss).
   * Se mide fuera de la zona de Angular porque solo escribe un estilo.
   */
  ngAfterViewInit(): void {
    const host = this.elementRef.nativeElement;
    const publish = () =>
      document.documentElement.style.setProperty("--header-height", `${host.offsetHeight}px`);
    publish();

    const ResizeObserverCtor = (window as any).ResizeObserver;
    if (!ResizeObserverCtor) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.headerResizeObserver = new ResizeObserverCtor(publish);
      this.headerResizeObserver.observe(host);
    });
  }

  /** Libera el observador del alto del header y las suscripciones. */
  ngOnDestroy(): void {
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
    }
    document.documentElement.style.removeProperty("--header-height");
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Abre o cierra el menu lateral flotante (telefonos y tablets). */
  toggleMobileMenu(): void {
    this.settings.toggleLayoutSetting("asideMobileOpen");
  }

  /**
   * Busca en el menu el item cuya ruta coincide con la URL actual y guarda su
   * texto como titulo. Si varias rutas coinciden, gana la mas especifica.
   */
  private updateSectionTitle(): void {
    const url = this.router.url.split("?")[0];
    const matches = (link: string) => !!link && (url === link || url.startsWith(`${link}/`));
    let best = { text: "", length: 0 };

    (this.menu.getMenu() || []).forEach((item: any) => {
      [item, ...(item.submenu || [])].forEach((entry: any) => {
        if (matches(entry.link) && entry.link.length > best.length) {
          best = { text: entry.text, length: entry.link.length };
        }
      });
    });
    this.sectionTitle = best.text;
  }

  /**
   * Nombre mostrado en "Acceso temporal": subcliente o cliente seleccionado.
   * @returns nombre del cliente/subcliente con acceso temporal.
   */
  temporaryAccessName(): string {
    const client = this.storageService.localValue.client;
    if (!client || !client.user) {
      return "";
    }
    if (client.user.is_subclient) {
      return client.user.first_name;
    }
    return client.user.client && client.user.client.name
      ? client.user.client.name
      : client.user.username;
  }

  /**
   * Logo del usuario en sesion (cliente o subcliente).
   * @returns url del logo o cadena vacia si no tiene.
   */
  userLogo(): string {
    if (!this.user) {
      return "";
    }
    if (this.user.is_subclient) {
      return this.user.subclient && this.user.subclient.logo ? this.user.subclient.logo : "";
    }
    return this.user.client && this.user.client.logo ? this.user.client.logo : "";
  }

  /**
   * Nombre del usuario en sesion.
   * @returns nombre y apellido, o el usuario si no los tiene.
   */
  userDisplayName(): string {
    if (!this.user) {
      return "";
    }
    const name = `${this.user.first_name || ""} ${this.user.last_name || ""}`.trim();
    return name || this.user.username;
  }

  /**
   * Rol del usuario en sesion.
   * @returns clave i18n del rol (administrador, cliente o subcliente).
   */
  userRoleKey(): string {
    if (!this.user) {
      return "";
    }
    if (this.user.user_type === 2 || this.user.is_subclient) {
      return "tables.subclient";
    }
    return this.user.user_type === 1 ? "tables.client" : "sidebar.administrator";
  }

  /**
   * Indica si el usuario puede abrir su perfil (solo clientes y subclientes).
   * @returns true si es cliente o subcliente.
   */
  canEditProfile(): boolean {
    return !!this.user && (this.user.user_type === 1 || this.user.user_type === 2);
  }

  /**
   * Abre el modal de perfil con los datos actuales del cliente.
   * @param template plantilla del modal de perfil.
   */
  async openProfile(template: TemplateRef<any>): Promise<void> {
    if (!this.canEditProfile()) {
      return;
    }
    const clientId = this.user.is_subclient
      ? this.user.subclient && this.user.subclient.client
      : this.user.client && this.user.client.id;
    try {
      const client = clientId ? await this.clientsService.getClient(clientId).toPromise() : null;
      this.profileUser = client ? { ...this.user, client } : this.user;
    } catch (error) {
      this.profileUser = this.user;
    }
    this.Modal(template, "show");
  }

  /**
   * Refleja en el header los datos guardados desde el modal de perfil.
   * @param profile respuesta del cliente/subcliente actualizado.
   */
  submitUser(profile: any): void {
    const owner = this.user.is_subclient ? this.user.subclient : this.user.client;
    if (owner) {
      owner.logo = profile.logo;
    }
    this.user = {
      ...this.user,
      email: profile.user.email,
      first_name: profile.user.first_name,
      last_name: profile.user.last_name
    };
  }

  Modal = (template: TemplateRef<any>, type) => {
    switch (type) {
      case "show":
        this.modalService.open(template, {
          backdrop: true,
          keyboard: false,
          size: "md",
          centered: true,
          windowClass: "modal-config pos-modal"
        });
        break;
      case "hide":
        this.modalService.dismissAll();
        break;
      default:
    }
  };

  /** Cierra la sesion: elimina el token de notificaciones, limpia datos locales y va al login. */
  logout = async () => {
    const sucess = () => {
      /* Cancelamos peticiones pendientes para que no resuelvan luego con el token ya invalidado */
      this.storageService.cancelRequests();
      localStorage.removeItem("token");
      this.indexedDBService.clearAlldb();
      this.router.navigateByUrl("/login");
      this.storageService.animation("success", "Éxito", `Sesión cerrada`);
      localStorage.removeItem("name_firebase");
    };
    const logout = async () => {
      await this.AuthService.logout().subscribe((resp) => {
        sucess();
      });
    };
    try {
      const token: string | null = await this.afMessaging.getToken.toPromise();
      if (token) {
        try {
          await this.afMessaging.deleteToken(token).toPromise();
          await this.firebaseService.deleteByToken(token).toPromise();
          await logout();
        } catch (error) {}
      } else {
        logout();
      }
    } catch (error) {
      logout();
    }
  };

  toggleOffsidebar(event: Event) {
    event.stopPropagation();
    this.settings.toggleLayoutSetting("offsidebarOpen");
  }

  toggleCollapsedSideabar() {
    this.settings.toggleLayoutSetting("isCollapsed");
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText");
  }
  changeMode = async () => {
    const { mode, farm_id } = this.storageService.localValue;
    const local = this.storageService.localValue;

    this.storageService.localValue[this.getCurrentQuery()] = {
      ...local[this.getCurrentQuery()],
      current_url: this.url
    };
    this.storageService.localValue["farm_id"] = Number(farm_id);
    /* Se cancelan las peticiones del modo anterior antes de cambiar de token: las que
       siguieran en cola saldrian con el token nuevo y fallarian (404 en el cliente) */
    this.storageService.cancelRequests();
    this.storageService.localValue["mode"] = Number(mode === 1 ? 0 : 1);

    let editPreferences = await this.storageService
      .editPreferences(this.storageService.localValue)
      ?.toPromise();

    if (editPreferences) {
      if (mode === 1) {
        this.socketService.connectSocket([]);
        this.storageService.setItem("mode", 0);
        this.mode = false;
        this.indexedDBService.clearAlldb();
        this.notifications = [];
        this.view_farm = false;
      } else {
        this.socketService.connectSocket([]);
        this.getFarms(true);
        this.storageService.setItem("mode", 1);
        this.mode = true;
      }
    }
    const { client } = this.storageService.localValue;

    const query = this.storageService.localValue[this.getCurrentQuery()];
    const current_url = query && query.current_url ? query.current_url : "";

    this.validateClientAdminUrl(this.mode ? 1 : 0, client, current_url);
    this.requestPermission(true);
  };
  temporalClient: String | Number = "";
  getFarms(socket = false) {
    this.farms = [];
    let { farm_id, mode } = this.storageService.localValue;
    let clientId = this.storageService.getClientID();
    this.loading_farm = true;
    const submit_farms = (farms) => {
      if (farms.length > 0) {
        if (farm_id) {
          let someFarm = farms.some((item: any) => Number(item.id) === Number(farm_id));
          /* Si la granja guardada no es del cliente actual (p. ej. un admin que cambia
             de cliente) se usa la primera; setFarm ya registra el socket de la nueva
             granja y emite "farmId" para que el resto del layout se actualice */
          if (!someFarm) {
            farm_id = farms[0].id;
            this.setFarm(farm_id);
          } else if (socket) {
            this.socketService.connectSocket([
              {
                type: "gateways.add_listener",
                data: { farm: Number(farm_id) }
              }
            ]);
          }
        } else if (!farm_id) {
          this.setFarm(farms[0].id);

          if (this.storageService.validateSoloAdmin() && mode) {
            this.setFarm(farms[0].id);
          }
        }
        this.farms = farms;
      } else {
        this.farms = [];
      }

      this.loading_farm = false;
    };

    const query = this.farmService.sessionFarmsQuery(clientId);

    const getListFarm = () => {
      // Al iniciar se reutiliza la lista que ya pidio el guard
      const request =
        this.farmService.takePrefetchedFarms(query) || this.farmService.getFarms(query);
      request.subscribe((res) => {
        submit_farms(res);
      });
    };

    getListFarm();
  }

  getLangs() {
    return this.translator.getAvailableLanguages();
  }
  uploadPreferenceHeader(personal) {
    const { mode } = personal;
    let admin = this.globalFunction.validateSoloAdmin();

    if ((admin && mode === 1) || (!admin && !mode)) {
      this.getFarms();
    } else {
      this.loading_farm = false;
    }
    this.mode = mode === 1;
  }

  runHelp(content) {
    this.HelpService.runHelp(content, {});
  }

  getNotifications() {
    const object_query = {
      page: 1,
      page_size: 20,
      ordering: "-date",
      status: "0",
      farm_id: this.farm_selected ? this.farm_selected.id : "",
      current_cycle: true
    };
    const query = this.globalFunction.constructQuery(object_query);

    this.loading_notifications = true;
    this.notifications = [];
    this.notificationsService.getNotifications(query).subscribe(
      (res) => {
        this.notifications = res.notifications;
        this.countNotifications = res.count;
        this.loading_notifications = false;
      },
      () => {
        this.loading_notifications = false;
      }
    );
  }
  getSystemNotification() {
    const object_query = {
      pagination: `?page=1&page_size=20`,
      ordering: `&ordering=-date`,
      status: `&status=0`,
      farm: `&farm_is_null=true`
    };
    const query = Object.values(object_query).join("");

    this.loading_notifications = true;
    this.notifications = [];
    this.notificationsService.getNotifications(query).subscribe(
      (resp) => {
        if (this.view_farm) {
          this.notifications = resp.notifications;
          this.countNotifications = resp.count;
        }
        this.loading_notifications = false;
      },
      () => {
        this.loading_notifications = false;
      }
    );
  }
  unReadPerFarm() {
    this.loading_farm_notifications = true;
    this.countAllNotifications()
      .then((item: any) => {
        this.notifications = [];
        this.system_notification_count = item.system_count;
        this.farm_notifications = item.farms;
        this.countNotifications = item.system_count + item.count_farms;
        this.loading_farm_notifications = false;
      })
      .catch(() => {
        this.loading_farm_notifications = false;
      });
  }

  /**
   * Refresca el listado y los contadores de notificaciones al abrir el dropdown.
   */
  refreshNotificationsOnOpen() {
    this.view_farm = false;
    this.farm_selected = null;
    this.notifications = [];
    this.unReadPerFarm();
  }

  /**
   * Count all notifications including system and farm notifications.
   * Groups farm notifications by farm_name and aggregates counts.
   * @returns Promise with system notifications, counts, and grouped farm notifications
   */
  countAllNotifications = () => {
    return new Promise(async (resolve, reject) => {
      const object_query = {
        pagination: `?page=1&page_size=20`,
        ordering: `&ordering=-date`,
        status: `&status=0`,
        farm: `&farm_is_null=true`
      };
      const query = Object.values(object_query).join("");
      try {
        // Notificaciones del sistema y conteo por granja en paralelo
        const [system, farm] = await Promise.all([
          this.notificationsService.getNotifications(query).toPromise(),
          this.notificationsService.unReadPerFarm().toPromise()
        ]);

        const groupedFarms = farm.reduce((acc: any[], item: any) => {
          const existingFarm = acc.find((f: any) => f.farm_name === item.farm_name);
          if (existingFarm) {
            existingFarm.count += item.count;
            existingFarm.ponds.push(item.pond_name);
          } else {
            acc.push({
              farm_name: item.farm_name,
              count: item.count,
              ponds: [item.pond_name]
            });
          }
          return acc;
        }, []);

        let count = (array: any) => {
          return array.reduce((suma: number, item: any) => {
            if (item && typeof item === "object" && "count" in item) {
              return Number(suma) + item.count;
            }
            return Number(suma);
          }, 0);
        };
        resolve({
          system: system.notifications || [],
          system_count: system.count,
          count_farms: count(groupedFarms),
          farms: groupedFarms
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  /**
   * Select notifications for a specific farm and display them
   * @param farm Farm object with name, count, and optional ponds list
   */
  selectNotificationsFarm(farm: { farm_name: string; count: number; ponds?: string[] }) {
    this.view_farm = true;
    const farm_id = this.farms.find((item: any) => item.name === farm.farm_name);
    if (farm_id) {
      this.farm_selected = { ...farm, id: farm_id.id };
    }
    this.getNotifications();
  }

  markAsSeen(id) {
    if (id) {
      const obj = {
        notification_id: [Number(id)]
      };

      this.notificationsService.markNotificationAsSeen(obj).subscribe((res) => {
        this.getNotifications();
      });
    }
  }
  markAsSeenAll() {
    const obj = {
      notification_id: this.notifications.map((item) => item.id)
    };
    let objDiv = document.getElementById("notifications");
    if (objDiv) {
      objDiv.scrollTop = 0;
    }
    this.notificationsService.markNotificationAsSeen(obj).subscribe((res) => {
      this.getNotifications();
    });
  }
  closeNotification(idx) {
    this.pop_notifications.splice(idx, 1);
  }
  deleteNotification = (notification, idx) => {
    if (notification.data) {
      this.notificationsService
        .deleteNotification({ notification_id: [Number(notification.data.id)] })
        .subscribe((res) => {
          if (idx >= 0) {
            this.closeNotification(idx);
          }
        });
    }
  };
  redirectNotification = async (type: "farm" | "pop" | "general", notification?: any) => {
    const search_farm = (name: any) => {
      const selected = this.farms.find((item: any) => item.name === name);
      return selected;
    };

    if (type === "farm") {
      const farm = search_farm(this.farm_selected?.farm_name);
      if (farm) {
        if (Number(this.storageService.localValue.farm_id) !== Number(farm.id)) {
          this.storageService.localValue.farm_id = farm.id;
          this.setFarm(farm.id);
        }
        this.router.navigateByUrl("/client-notifications");
      }
      return;
    }

    if (!notification) {
      return;
    }

    // Unifica estructura de notificaciones API (details) y push (data.extra)
    const details = notification.details
      ? notification.details
      : notification.data && notification.data.extra
      ? notification.data.extra
      : null;

    if (!details) {
      this.router.navigateByUrl("/client-notifications");
      return;
    }

    const topic = notification.data && notification.data.topic ? notification.data.topic : "";
    if (topic === "dev_apks" || topic === "dev_systems") {
      this.router.navigateByUrl("/client-notifications");
      return;
    }

    const validate_farm =
      Number(this.storageService.localValue.farm_id) !== Number(details.farm_id);

    if (validate_farm && Object.prototype.hasOwnProperty.call(details, "farm_id")) {
      this.storageService.localValue.farm_id = details.farm_id;
      this.setFarm(details.farm_id);
    }

    const notificationKind = Number(notification.kind || details.kind || 0);

    if (notificationKind === 4 && details.pond_id) {
      try {
        const pond = await this.pondService
          .getPonds("?fields=id,farm", details.pond_id)
          .toPromise();
        const farmId = pond && pond.farm ? Number(pond.farm.id) : Number(details.farm_id);

        if (farmId) {
          if (Number(this.storageService.localValue.farm_id) !== farmId) {
            this.storageService.localValue.farm_id = farmId;
            this.setFarm(farmId);
          }
          this.router.navigateByUrl(
            `/granja/${details.pond_id}/(left:alimentadores//right:alimentacion)`
          );
          return;
        }
      } catch (error) {
        // Si falla la consulta del estanque, usa fallback de detalle
        const farmId = Number(details.farm_id);
        if (farmId && Number(this.storageService.localValue.farm_id) !== farmId) {
          this.storageService.localValue.farm_id = farmId;
          this.setFarm(farmId);
        }
        this.router.navigateByUrl(
          `/granja/${details.pond_id}/(left:alimentadores//right:alimentacion)`
        );
        return;
      }
    } else if (notificationKind !== 1 && details.pond_id) {
      this.router.navigateByUrl(`/parametrias/${details.pond_id}`);
    } else {
      this.router.navigateByUrl(`/client-notifications`);
    }
  };

  sendNotification() {
    const notification = {
      "11": {
        data: {
          id: "1590",
          extra:
            '{"pond_name": "1", "farm_name": "Jazaria", "value": 31.0, "exceeded": 30.0, "kind": 11, "pond_id": 252, "unit": "\\u00b0C"}',
          pond_name: "1",
          farm_name: "Jazaria",
          value: 31,
          exceeded: 30,
          kind: 11,
          pond_id: 252,
          date: new Date(),
          unit: "°C"
        },
        from: "740706149169",
        priority: "normal",
        notification: {
          title: "temperatura del estanque superó el MÁXIMO en est. 1",
          body: "temperatura del estanque superó el MÁXIMO en el estanque 1"
        },
        fcmMessageId: "0480d311-086a-497d-9296-729fbd960b23"
      }
    };
    this.pop_notifications.push(notification["11"]);
  }
}
